var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheatSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6151",
    "data-name": "Group 6151",
    transform: "translate(-1006 -293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5211",
    "data-name": "Path 5211",
    d: "M1021,293h-9v16h14V298a4.992,4.992,0,0,0-5-5Z",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5212",
    "data-name": "Path 5212",
    d: "M1008.4,309.061a2.907,2.907,0,0,1,.6-.061h1V293.1a5.009,5.009,0,0,0-4,4.9v12.025A4.977,4.977,0,0,1,1008.4,309.061Z",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5213",
    "data-name": "Path 5213",
    d: "M1026,311h-17a3,3,0,0,0,0,6h12a4.933,4.933,0,0,0,1.91-.381A4.994,4.994,0,0,0,1026,312Z",
    fill: "#136ad0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheatSheet);
export default __webpack_public_path__ + "static/media/cheat-sheet.805a0ab0031e08f0206889071f558f8e.svg";
export { ForwardRef as ReactComponent };